import { api } from '../../api';
export const getDashboardData = (token) =>{
    return new Promise((resolve,reject)=>{
        api.dashboard.getDashboardData({},token).then(res=>{
            resolve(res);
        }).catch(err=>{
            reject([])
        });
    });
}
export const dashboardGraph = (token) =>{
    return new Promise((resolve,reject)=>{
        api.dashboard.getDashboardGraph({},token).then(res=>{
            resolve(res);
            // console.log(res, ' graphhhhh')
    }).catch(err=>{
        reject([])
    })
})
}
